export default __webpack_public_path__ + "static/media/comparison-ES.14fdfbcb.mp4";